import { nanoid } from 'nanoid';
import { ACTION_TYPES } from '../../../../components/UI/MDC/DataTable/_types';
import { prettyDateFormat } from '../../../../utils/strings/StringUtil';

export const applicationSet = new Set();
export const APP_IDENTIFIER_TYPES = {
	All: 'All',
};

/**
 * Function takes a @param {object} from the WorkQueue API
 *
 * @returns {Array} array of rows objects for the data table component.
 */
/**
 * Takes an object of specific format and returns an array of rows for the datatable component
 *
 * @function
 * @param {Object} requestData object returned from the WorkQueue API
 * @param {Object} dataCorrelation object with keys that maps to object returned from WorkQueue API
 * @returns {Array} array of rows objects for the data table component.
 */
export const generateRowData = (requestData, dataCorrelation) => {
	var rowData = [
		// ActionCells = [],
		// Cells = undefined,
		// key: nanoid,
		// isDisplayed: true
	];

	// mainLevel keys
	var mainLevelKeys = Object.keys(dataCorrelation.mainLevel);
	var mainLevelValues = Object.values(dataCorrelation.mainLevel);

	// const mySet = new Set();
	requestData.forEach(item => {
		// Initiate empty Cells object
		let Cells = {};

		// Map through main level
		// Only need to do this once per request, since there can be many applications per request array
		mainLevelKeys.map(
			(key, index) =>
				(Cells[key] = {
					Value:
						key === 'Request Date' || key === 'Create Date'
							? prettyDateFormat(item[mainLevelValues[index]])
							: item[mainLevelValues[index]],
					Validation: {
						Key: true.toString(),
						Value: null,
						memberToValidateKey: null,
					},
				})
		);

		// Generate Action Cells Array
		let ActionCellsArray = [
			{
				BindTo: 0,
				Checked: false,
				Key: nanoid(),
				Text: 'Delete',
				Type: ACTION_TYPES.CHECKBOX,
			},
		];

		// Create cell row and push to rows array
		let CellRow = {
			ActionCells: ActionCellsArray,
			Cells: Cells,
			isDisplayed: true,
			Key: nanoid(),
		};

		rowData.push(CellRow);
	});
	return rowData;
};
